import {handleError} from "../generators/helpers";
import service from '@/api/profile';

export const state = {
    loadingMe: false,
    me: {},
    service: service('profiles')
};
export const getters = {
    loadingMe: function (state) {
        return !!state.loadingMe;
    },
    me: function (state) {
        return JSON.parse(JSON.stringify(state.me));
    },
};
export const mutations = {
    'SET_LOADING_ME': function (state, boolean = true) {
        state.loadingMe = boolean;
    },
    'SET_ME': function (state, item = {}) {
        state.me = item;
    },
};

export const actions = {
    me: function ({commit, state}) {
        commit('SET_LOADING_ME');

        return state.service.me().then(response => {
            commit('SET_ME', response.data);
            commit('SET_LOADING_ME', false );

            return response.data;
        }).catch((e) => {
            commit('SET_LOADING_ME', false );
            handleError(e, commit)
        })
    },
};
